import React, { Fragment, useEffect, useState } from 'react'
import axios from '@src/configs/axios/axiosConfig'
import { useDispatch, useSelector } from 'react-redux'
import { Badge, Card, CardBody, CardHeader, Input, Progress, Spinner } from 'reactstrap'
import { Trash, X } from 'react-feather'
import { fileStoreInredux } from './store'
const xlsimage = require('@src/assets/images/icons/xls.png').default
const docimage = require('@src/assets/images/icons/docs.png').default
const pdfimage = require('@src/assets/images/icons/pdf.png').default
const pngimage = require('@src/assets/images/icons/png.png').default
const pptimage = require('@src/assets/images/icons/ppt.png').default

const FileUploadForm = () => {

    const imageOption = [
        { type: ['xlsx', 'xls'], Image: xlsimage },
        { type: ['docs'], Image: docimage },
        { type: ['pdf'], Image: pdfimage },
        { type: ['png', 'jpg', 'jpeg', 'gif'], Image: pngimage },
        { type: ['ppt'], Image: pptimage }
    ]
    const dispatch = useDispatch()

    const srcPath = (file) => {
        const temp = imageOption.find((oj) => oj?.type?.includes(file?.extension))
        return temp?.Image ?? ''
    }
    const store = useSelector(state => state.fileUpload)

    const [files, setFiles] = useState([])
    const [uploading, setUploading] = useState(false)
    const [uploadProgress, setUploadProgress] = useState(0)

    const updateAttachment = async (data) => {
        await axios.post('/files/updateAttachment', data)
            .then(() => {
                setUploading(false)
                dispatch(fileStoreInredux(null))
                setFiles([])
            }).catch(err => console.log(err))
    }

    const uploadFile = async (formData) => {

        setUploading(true)

        await axios.post('/files/upload', formData, {
            onUploadProgress: (progressEvent) => {
                const { loaded, total } = progressEvent
                setUploadProgress(Math.round((loaded * 100) / total))
            }
        }).then((res) => {
            updateAttachment({ existAttachmentIds: store?.formData?.existAttachmentIds, attachmentIds: res?.data.attachment_ids, id: store?.formData?.moduleId, table: store?.formData?.tableName })
        }).catch(() => {
            setUploading(false)
        })

    }

    useEffect(() => {
        if (store?.formData) {
            setFiles(store?.formData?.files)
            uploadFile(store?.formData?.form)
        }
    }, [store?.formData])

    return (
        <Fragment>
            {
                files?.length > 0 &&
                <Card className={'fileupload-container width-25-per height-30-per'}>
                    <CardHeader className={'bg-light-primary p-1'}>
                        <h5>Uploading {files.length} itmes</h5>
                        <X size={14} />
                    </CardHeader>
                    <CardBody>
                        {uploading && (
                            <Progress className={`mt-1 ${uploadProgress === '100' ? 'progress-bar-success' : 'progress-bar-primary'}`} value={uploadProgress}>{uploadProgress}%</Progress>
                        )}
                        <div className='p-1'>
                            {
                                files.map((file, index) => {
                                    return (
                                        <div key={index} className='d-flex justify-content-between mb-1' >
                                            <div className='d-flex align-items-center'>
                                                <img className='width-10-per' src={srcPath(file)} />
                                                <p className='mt-50 mb-0 ms-1 text-truncate'>{file.name}</p>
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                {uploading &&
                                                    <div className='d-flex mt-50'>
                                                        <Spinner className='me-25' size='sm' />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </CardBody>
                </Card>
            }
        </Fragment>
    )
}

export default FileUploadForm